// Global Sass-like variables for use within CSS
// See https://github.com/postcss/postcss-simple-vars#variables
// Pixel calculations assume 1rem = 16px

const variables = require('../../config/variables');

const breakpointSMInt = 512;
const breakpointMDInt = 768;
const breakpointLGInt = 1160;

const gridBaseLineInt = 1.875;

const headerStackedListBreakpointInt = 1130;

module.exports = {
  // Colour definitions
  torchRed: '#ff1040',
  crimson: '#e4133f',
  lavendar: '#ffe7eb',
  malibu: '#50b5ff',
  aliceblue: '#f0fAff',
  teal: '#40acce',
  serenade: '#fff7e9',
  black: '#000',
  white: '#fff',
  darkerGrey: '#818c99',
  darkGrey: '#c0c0c0',
  grey: '#7D8996',
  lightGrey: '#979797',
  lightGrey100: '#e0e0e0',
  lighterGrey: '#ebebeb',
  lightestGrey: '#f9f9f9',
  facebookBlue: '#33589d',
  stravaOrange: '#fc4c02',
  errorRed: '#ff0000',
  successGreen: '#4db37c',
  lightGreen: '#f5faf6',
  featuredGreen: '#69B081',
  featuredGold: '#ffc411',
  lightGold: '#fff8e1',
  purple: '#ca6dcc',
  grey5: '#f5f5fa',
  grey4: '#e3e3ec',
  grey3: '#babac6',
  grey2: '#7f7f8d',
  grey1: '#494955',

  // Color settings
  colorBrand: '$torchRed',
  colorBrandSecondary: '$crimson',
  colorBorder: '$lighterGrey',
  colorBorderDark: '$darkGrey',
  colorBorderTransparent: 'color($white a(20%))',

  // widget related
  widgetBackgroundColor: '$white',
  widgetCardBackgroundColor: '$white',
  widgetCardBackgroundColorHover: '$lightestGrey',

  // Arrows used in carousels
  arrowColor: '$colorBrand',

  // Breakpoints
  breakpointSMInt,
  breakpointMDInt,
  breakpointLGInt,

  breakpointSM: `${breakpointSMInt}px`,
  breakpointMD: `${breakpointMDInt}px`,
  breakpointLG: `${breakpointLGInt}px`,

  // Container
  containerMaxWidthSM: '320px',
  containerMaxWidthMD: '648px',
  containerMaxWidthLG: '1080px',

  // Grid
  gridColumnsSM: 6,
  gridColumnsMD: 12,
  gridColumnsLG: '$gridColumnsMD',

  gridBaseLineInt,

  gridGutterWidthXSM: '.625rem', // 10px
  gridGutterWidthSM: '1.125rem', // 18px
  gridGutterWidthMD: '$gridGutterWidthSM',
  gridGutterWidthLG: `${gridBaseLineInt}rem`, // 30px

  gridOffsetWidthSM: '0px',
  gridOffsetWidthMD: '$gridGutterWidthMD',
  gridOffsetWidthLG: '$gridGutterWidthLG',

  gridBaseline: `${gridBaseLineInt}rem`, // 30px
  gridDebug: false,

  // Type
  fontFamily: 'pangram, sans-serif',
  fontSize: '1rem', // Assumes the browser default, typically 16px
  fontWeight: 300, // Weights must match font-face definitions
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  lineHeight: '$gridBaseline',
  lineHeightSmall: 1.16,
  lineHeightMedium: 1.5,
  bodyTextColor: '$black',
  bodyBgColor: '$lightestGrey',

  // Headings
  headingsMarginTop: 'calc($gridBaseline / 2)',
  headingsMarginBottom: 'calc($gridBaseline / 2)',
  headingsFontFamily: '$fontFamily',
  headingsFontWeight: '$fontWeightBold',
  headingsLineHeight: '$gridBaseline',
  headingsColor: 'inherit',

  // Sizes
  fontSizeHero: '1.875rem', // 30px
  fontSizeH1: '1.625rem', // 26px
  fontSizeH2: '1.375rem', // 22px
  fontSizeH3: '1.125rem', // 18px
  fontSizeH4: '1rem', // 16px
  fontSizeH5: '1rem', // 16px
  fontSizeH6: '1rem', // 16px
  fontSizeSM: '0.875rem', // 14px

  // Links
  linkColor: '$torchRed',
  linkColorDark: '$black',
  linkHoverColor: '$torchRed',

  // Component dimensions
  borderWidth: '0.0625rem',
  borderStyle: '$borderWidth solid $colorBorder',
  borderRadius: '0.1875rem', // 3px
  borderRadiusLG: '0.25rem', // 4px
  boxShadowStyle: '0 0.0625rem 0.125rem rgba(0, 0, 0, 0.03)', // 0 1px 2px

  // Header
  headerStackedListBreakpointInt,

  headerHeight: '4.375rem', // 70px, used to determine page height
  headerStackedListBreakpoint: `${headerStackedListBreakpointInt}px`,

  // Z-indexes
  zIndexBehind: -1,
  zIndexImageGradient: 950,
  zIndexSticky: 970,
  zIndexDropdown: 1000,
  zIndexFixed: 1030,
  zIndexOverlay: 1100,
  zIndexAnchorNavigation: 5000,
  zIndexHeader: 5001,
  zIndexModal: 5050,
  zIndexPlacepicker: 5051,
  zIndexHelpText: 5555,
  zIndexDiscountBanner: 5001,
  zIndexFullScreenLightbox: 5008,

  // Media root
  mediaRoot: variables.default.MEDIA_ROOT,
};
